import { Component, ReactNode } from 'react';
import { Text, View } from 'react-native';
import { colors, fonts } from '../theme';
import { Button } from './ui';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/** Without this, a single uncaught render-time exception in ANY screen (e.g.
 * an API response shape mismatch hitting .map() on undefined) took the whole
 * app down to a blank/red screen with no recovery path except force-quitting
 * — there is no crash-reporting SDK wired up either, so it would also be
 * invisible after the fact. This at least gives the user a way back in and
 * logs the error to the console for now. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    // eslint-disable-next-line no-console
    console.error('Unhandled render error caught by ErrorBoundary:', error, info.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24, backgroundColor: colors.background }}>
          <Text style={{ fontFamily: fonts.bold, fontSize: 18, color: colors.text, marginBottom: 8, textAlign: 'center' }}>
            Đã có lỗi xảy ra
          </Text>
          <Text style={{ color: colors.textMuted, fontSize: 14, marginBottom: 20, textAlign: 'center' }}>
            Rất tiếc, ứng dụng gặp sự cố. Vui lòng thử lại.
          </Text>
          <Button title="Thử lại" onPress={this.reset} />
        </View>
      );
    }
    return this.props.children;
  }
}
